import './src/styles/theme-overrides.css';
import './src/styles/custom-sections.css';

import React from 'react';
import { Analytics } from '@vercel/analytics/react';

export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <Analytics />
  </>
);
